import { getLink, getButton } from '../dashboardCommon/utils';
import { orderStatus, fmFilterStatuses } from '../../utils/constant';
import { useLocaleContext } from '../../context/LocaleContext';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const getStatus = (order, discountStatus) => {
  const local = useLocaleContext();

  const {
    srtDashboardFM: { status }
  } = local === 'en-US' ? EN : FR;

  const incomplete = order === orderStatus.incomplete;
  const pendingValidation = order === orderStatus.pendingValidation;
  const contractSend = order === orderStatus.contractSend;
  const contractSigned = order === orderStatus.contractSigned;
  const completed = order === orderStatus.submitted;
  const orderCanceled = order === orderStatus.canceled;
  const sendBacktoAccountManager = order === orderStatus.SendBacktoAccountManager;

  const statusList = {
    [incomplete]: status.orderIncomplete,
    [pendingValidation]: status.pendingValidation,
    [contractSend]: status.contractSent,
    [contractSigned]: status.contractSigned,
    [completed]: status.orderCompleted,
    [orderCanceled]: status.orderCanceled,
    [sendBacktoAccountManager]: status.sendBacktoAccountManager
  };

  let finalStatus = statusList.true;

  if(statusList.true === status.orderIncomplete && discountStatus && discountStatus !== 'Auto-Approved') {
    finalStatus = `Discount ${discountStatus}`.replace('-', ' ');
  }

  return finalStatus;
};

const exactCompareArray = (arrOne, arrTwo) => {
  return (
    arrOne.length === arrTwo.length &&
    arrOne.filter((currVal, idx) => currVal !== arrTwo[idx]).length === 0
  );
};

const getOrderType = (productSelected = []) => {
  const local = useLocaleContext();
  const {
    srtDashboardFM: {
      microsoftLicensingFM,
      managedItServicesFM,
      managedDetectionResponseFM,
      fmITMDR,
      fmITLicensing,
      fmProducts,
      orderType
    }
  } = local === 'en-US' ? EN : FR;
  let type = '';
  if (exactCompareArray(fmProducts, productSelected)) {
    type = orderType.fmProducts;
  } else if (exactCompareArray(microsoftLicensingFM, productSelected)) {
    type = orderType.microsoftLicensingFM;
  } else if (exactCompareArray(managedItServicesFM, productSelected)) {
    type = orderType.managedItServicesFM;
  } else if (exactCompareArray(managedDetectionResponseFM, productSelected)) {
    type = orderType.managedDetectionResponseFM;
  }
  else if (exactCompareArray(fmITMDR, productSelected)) {
    type = orderType.fmITMDR;
  }
  else if (exactCompareArray(fmITLicensing, productSelected)) {
    type = orderType.fmITLicensing;
  }
  else {
    type = '-';
  }
  return type;
};

const filterValueToStatusesMap = {
  [fmFilterStatuses.incomplete]: {
    orderStatus: orderStatus.incomplete
  },
  [fmFilterStatuses.submitted]: {
    orderStatus: orderStatus.submitted
  },
  [fmFilterStatuses.pendingValidation]: {
    orderStatus: orderStatus.pendingValidation
  },
  [fmFilterStatuses.orderCanceled]: {
    orderStatus: orderStatus.canceled
  },
  [fmFilterStatuses.contractSigned]: {
    orderStatus: orderStatus.contractSigned
  },
  [fmFilterStatuses.contractSent]: {
    orderStatus: orderStatus.contractSend
  }
};

const getStatusFiltersPayload = filters => {
  const statuses = [];
  filters.forEach(element => {
    if (filterValueToStatusesMap[element.value]) {
      const correspondingOrderStatus =
        filterValueToStatusesMap[element.value].orderStatus;

      if (
        correspondingOrderStatus &&
        !statuses.includes(correspondingOrderStatus)
      )
        statuses.push(correspondingOrderStatus);
    }
  });
  return { status: statuses };
};

export { getLink, getButton, getStatus, getOrderType, getStatusFiltersPayload };
